<template>
<div class="container">
  <div class="main">
    <div class="thumb-example">

      <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">

        <swiper-slide class="slide-2"
          v-for="(item,i) in picData" :key="i"
          :style="{ 'background-image': 'url('+ item +')'}"
        ></swiper-slide>

        <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
        <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
      </swiper>
      <!-- swiper2 Thumbs -->
      <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
        <swiper-slide class="slide-2" v-for="(item,i) in picData" :key="i"
          :style="{ 'background-image': 'url('+ item +')'}">
        </swiper-slide>
      </swiper>

    </div>
  </div>
</div>

</template>

<script>
  import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
  import 'swiper/css/swiper.css'
  export default {
    name: 'swiper-example-thumbs-gallery',
    title: 'Thumbs gallery with Two-way control',
    components: {
      Swiper,
      SwiperSlide
    },
    data() {
      return {
        swiperOptionTop: {
          loop: true,
          loopedSlides: 5, // looped slides should be the same
          spaceBetween: 10,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          // lazy: {
          //   loadPrevNext: true
          // },
        },
        swiperOptionThumbs: {
          loop: true,
          loopedSlides: 5, // looped slides should be the same
          spaceBetween: 10,
          centeredSlides: true,
          slidesPerView: 'auto',
          touchRatio: 0.2,
          slideToClickedSlide: true ,
        } ,
        picData : [
          'https://dixcel.cn/prod/2020领克03+登山赛/1.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/2.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/3.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/4.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/5.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/6.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/7.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/8.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/9.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/10.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/11.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/12.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/13.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/14.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/15.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/16.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/17.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/18.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/19.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/20.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/21.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/22.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/23.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/24.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/25.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/26.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/27.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/28.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/29.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/30.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/31.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/32.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/33.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/34.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/35.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/36.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/37.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/38.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/39.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/40.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/41.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/42.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/43.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/44.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/45.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/46.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/47.jpg',
          'https://dixcel.cn/prod/2020领克03+登山赛/48.jpg',
        ]
      }
    },
    mounted() {
      this.$nextTick(() => {
        const swiperTop = this.$refs.swiperTop.$swiper
        const swiperThumbs = this.$refs.swiperThumbs.$swiper
        swiperTop.controller.control = swiperThumbs
        swiperThumbs.controller.control = swiperTop
      })
    }
  }
</script>

<style lang="stylus" scoped>
  .container
    background-color : #000
    .box_one
      width: 100%;

    .box_bottom
      width: 100%;
      background-color #000


  .main {
    margin-bottom: 5px;
    width: 1003px;
    background-color: #fff;
    margin: 0 auto;
    position: relative;
    box-sizing: border-box;
    padding: 62px 50px 52px;
  }

  .thumb-example {
    height: 680px;
    background-color: $black;
  }
  .swiper {
    .swiper-slide {
      background-size: 100%;
      background-position: center center;
      background-repeat no-repeat
    }
    &.gallery-top {
      height: 80%;
      width: 100%;
    }
    &.gallery-thumbs {
      height: 20%;
      box-sizing: border-box;
      padding: $gap 0;
    }
    &.gallery-thumbs .swiper-slide {
      width: 20%;
      height: 100%;
      opacity: 0.4;
    }
    &.gallery-thumbs .swiper-slide-active {
      opacity: 1;
    }
  }
</style>
